module.exports = __webpack_public_path__ + "media/images/slider-big-arrow-right-a7b3407379bf875895836bab999cba24.png";